// get ecustomer list for admin workforce
export const RESET_CUSTOMER_ACTIVATION_EMAIL =
    "RESET_CUSTOMER_ACTIVATION_EMAIL";
export const CUSTOMER_ACTIVATION_EMAIL = "CUSTOMER_ACTIVATION_EMAIL";
export const CUSTOMER_ACTIVATION_EMAIL_SUCCESS =
    "CUSTOMER_ACTIVATION_EMAIL_success";
export const CUSTOMER_ACTIVATION_EMAIL_FAILURE =
    "CUSTOMER_ACTIVATION_EMAIL_failure";
